var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopularCities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17566",
    "data-name": "Group 17566",
    transform: "translate(-919 -686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_16-location",
    "data-name": "16-location",
    transform: "translate(871 685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(52 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8352",
    "data-name": "Path 8352",
    d: "M183.9,100h-3.567a.334.334,0,0,0-.334.334v5.684h1.338v-1.672a.334.334,0,0,1,.334-.334h.892a.334.334,0,0,1,.334.334v1.672h1.338v-5.684A.334.334,0,0,0,183.9,100Zm-2.786,3.009a.334.334,0,0,1-.669,0v-.446a.334.334,0,0,1,.669,0Zm0-1.783a.334.334,0,0,1-.669,0v-.446a.334.334,0,0,1,.669,0Zm1.338,1.783a.334.334,0,0,1-.669,0v-.446a.334.334,0,0,1,.669,0Zm0-1.783a.334.334,0,0,1-.669,0v-.446a.334.334,0,0,1,.669,0Zm1.338,1.783a.334.334,0,0,1-.669,0v-.446a.334.334,0,0,1,.669,0Zm0-1.783a.334.334,0,0,1-.669,0v-.446a.334.334,0,0,1,.669,0Z",
    transform: "translate(-176.433 -97.325)",
    fill: "#c22127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8353",
    "data-name": "Path 8353",
    d: "M57.684,4A5.691,5.691,0,0,0,52,9.684a6.654,6.654,0,0,0,.875,3.1,13.851,13.851,0,0,0,1.884,2.635,20.574,20.574,0,0,0,2.724,2.553.334.334,0,0,0,.4,0,20.571,20.571,0,0,0,2.724-2.553,13.848,13.848,0,0,0,1.884-2.635,6.653,6.653,0,0,0,.875-3.1A5.691,5.691,0,0,0,57.684,4Zm0,10.143A4.447,4.447,0,0,1,54.4,12.694h.834V9.8h-2q0-.056,0-.111a4.458,4.458,0,1,1,8.917,0q0,.056,0,.111h-2v2.9h.834A4.447,4.447,0,0,1,57.684,14.143Z",
    transform: "translate(-52 -4)",
    fill: "#c22127"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(919 686)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularCities);
export default __webpack_public_path__ + "static/media/popular_cities.b64542acc366738bfa20fe7b22ebdfa8.svg";
export { ForwardRef as ReactComponent };